import { Component, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

import { ImageComponent } from '@atoms/image/image.component';

@Component({
  selector: 'app-card-photo',
  imports: [NgStyle, ImageComponent],
  templateUrl: './card-photo.component.html',
  styleUrls: ['./card-photo.component.scss'],
})
export class CardPhotoComponent {
  @Input() src?: string;
  @Input() placeholder?: string;
  @Input() alt: string = '';
  @Input('aspect-ratio') aspectRatio?: string;
  @Input() priority: boolean = false;
  @Input() position?: string;
}
